import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import IImage from '../../models/viewModels/base/IImage';
import IVideo from '../../models/viewModels/base/IVideo';
import { Entry } from 'contentful';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';

export default class MediaGalleryComponentModel extends BaseComponentModel {
  gallery: Array<IImage | IVideo>;

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = ['gallery'];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'Image';

  constructor(data: any, appSettings: ApplicationSettings) {
    super('mediaGallery', appSettings);

    const mediaGalleryShouldReturn = this.shouldReturnEntity(data);

    if (!mediaGalleryShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...mediaGalleryShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.gallery = data.gallery
      ?.map((x) => {
        const contentType = x?.sys?.contentType ? x?.sys?.contentType?.sys?.id : null;
        const fields = x?.fields;

        if (contentType === `componentVideo` && fields?.video?.length) {
          const video = fields?.video[0];
          return {
            src: video?.secure_url,
            secureUrl: video?.secure_url,
            description: fields?.title,
            title: fields?.title ?? null,
            caption: fields?.caption ?? null,
            resourceType: 'video',
            height: video?.height,
            width: video?.width,
            type: video?.type,
            format: video?.format,
            previewImageSecureURL: fields?.previewImage?.fields?.image
              ? fields?.previewImage?.fields?.image[0]?.secure_url
              : null,
            previewImageAlt: fields?.previewImage?.fields?.altText,
            id: fields?.id,
          } as IVideo;
        } else if (contentType === `componentImage` && x?.fields?.image?.length) {
          return {
            secureUrl: fields?.image[0]?.secure_url,
            alt: fields?.altText,
            size: fields?.size,
            format: `f_jpg`,
            resourceType: `image`,
            title: fields?.title ?? null,
            caption: fields?.caption ?? null,
            id: fields?.id ?? null,
          } as IImage;
        }

        return null;
      })
      .filter(Boolean);
  }
}
